import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiV2Root } from "consts";

import {
  NOTIFICATIONS_QUERY_KEY,
  type CheckResponse,
  type NotificationChannel,
} from "./data/types";

/** Отмечает канал уведомлений просмотренным и обновляет счётчик в шапке. */
export const useCheckNotifications = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation<CheckResponse, Error, NotificationChannel>({
    mutationFn: async (channel) => {
      const response = await fetch(`${apiV2Root}notifications/check/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ channel }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.error || `HTTP ${response.status}`);
      }

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [NOTIFICATIONS_QUERY_KEY] });
    },
  });

  return {
    check: mutation.mutate,
    isChecking: mutation.isPending,
    error: mutation.error,
  };
};
